// extracted by mini-css-extract-plugin
module.exports = {"Hero":"StoryHero_Hero__yLwqa","Hero-text":"StoryHero_Hero-text__3BYnt","citation":"StoryHero_citation__3228s"};